var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgReloadLeft = function SvgReloadLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 17",
    fill: "#851A92",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.387 7.694 19.095 6.4l-1.228-1.229c-.258-.258-.776-.258-1.099 0l-1.293 1.293-1.228 1.229c-.259.258-.194.517.258.517h1.487c0 3.168-2.586 5.754-5.754 5.754a5.711 5.711 0 0 1-4.073-1.681l-1.94 1.94c1.552 1.551 3.686 2.52 6.013 2.52 4.72 0 8.47-3.814 8.47-8.533h1.422c.388 0 .517-.259.258-.517ZM6.293 9.051c.259-.258.194-.582-.258-.582H4.548c0-3.168 2.586-5.754 5.754-5.754 1.616 0 3.038.647 4.073 1.746l1.94-1.94A8.246 8.246 0 0 0 10.365 0a8.457 8.457 0 0 0-8.47 8.47H.41c-.453 0-.517.258-.259.581L1.38 10.28l1.293 1.293c.258.258.775.258 1.099 0L5 10.28 6.293 9.05Z"
  })));
};

export default SvgReloadLeft;